import React from 'react';
import { ServerMsgContainer, Recommend } from '../../../components';
import { useMessageById } from '../../../hooks';
var RecommendCard = function (props) {
    var messageId = props.messageId;
    var messageState = useMessageById(messageId);
    var _a = messageState.payload.message, message = _a === void 0 ? [] : _a;
    return (React.createElement(ServerMsgContainer, { maxWidth: true, id: "guess_question" },
        React.createElement(Recommend, { message: message, type: 'guess-question' })));
};
export default RecommendCard;
